import React from "react";
import { compose, withStateHandlers, lifecycle } from "recompose";
import withRouter from "react-router-dom/withRouter";
import Switch from "react-router-dom/Switch";
import Route from "react-router-dom/Route";
import Transition from "react-transition-group/Transition";
import ReactGA from "react-ga";

import Home from "package-common-react/lib/pages/Home";
import Play from "package-common-react/lib/pages/Play";
import Registration from "package-common-react/lib/pages/Registration";
import routes from "package-common-react/lib/routes";

import PreHome from "../../pages/PreHome";
import HomeContent from "../HomeContent";
import PlayResults from "../PlayResults";
import {
  RegistrationHeading,
  RegistrationSuccessPanel,
  RegistrationErrorPanel
} from "../RegistrationComponents";

import { Pages, PageContent } from "./style";
import MainLayout from "../MainLayout";
import config from "../../config";

const Page = function({ duration, children, ...props }) {
  return (
    <Transition timeout={duration} {...props}>
      {state => <PageContent state={state}>{children}</PageContent>}
    </Transition>
  );
};

export default compose(
  withRouter,
  withStateHandlers(
    { previousLocation: null, locationsHistory: [] },
    {
      addLocation: ({ locationsHistory }) => location => {
        return {
          previousLocation: locationsHistory.length
            ? locationsHistory[locationsHistory.length - 1]
            : null,
          locationsHistory: [...locationsHistory.slice(0, 4), location]
        };
      }
    }
  ),
  lifecycle({
    componentWillReceiveProps({ location }) {
      if (location !== this.props.location) {
        this.props.addLocation(location);
      }
    }
  })
)(function AppPages({ previousLocation, location }) {
  ReactGA.pageview(location.pathname + location.search);

  let duration, animation;
  if (location) {
    switch (location.pathname) {
      case routes.play.path:
        duration = 500;
        animation = "slide";
        break;
      case routes.home.path:
        if (previousLocation && previousLocation.pathname !== "/") {
          duration = 500;
          animation = "slideReverse";
        } else {
          duration = 500;
          animation = "slide";
        }
        break;
      default:
        duration = 300;
        animation = "fade";
    }
  }
  const routeProps = { location };
  const HomeComponent = function(props) {
    return (
      <Home {...props}>
        <HomeContent />
      </Home>
    );
  };
  const hasEnded = new Date() > config.endDate;
  return (
    <Pages duration={duration} animation={animation}>
      <Page key={location.key} duration={duration}>
        <Switch location={location}>
          <Route exact path="/" component={PreHome} {...routeProps} />
          {routes.home.match(routeProps)(HomeComponent)}
          {!hasEnded && (
            <React.Fragment>
              {routes.play.match(routeProps)(function(props) {
                return (
                  <MainLayout>
                    <Play results={PlayResults} {...props} />
                  </MainLayout>
                );
              })}
              {routes.registration.match(routeProps)(function(props) {
                return (
                  <MainLayout>
                    <Registration
                      labelFormStore="Mon magasin Pièces Auto"
                      heading={RegistrationHeading}
                      successPanel={RegistrationSuccessPanel}
                      errorPanel={RegistrationErrorPanel}
                      {...props}
                    />
                  </MainLayout>
                );
              })}
            </React.Fragment>
          )}
          {routes.error404.match(routeProps)()}
        </Switch>
      </Page>
    </Pages>
  );
});



// WEBPACK FOOTER //
// ./src/components/AppPages/index.js